<ng-container *transloco="let t">
  <div class="px-3 py-4 grid grid-cols-3 gap-4">
    <ng-container *ngFor="let link of categoryLinks">
      <button
        [class]="
          (restrictUser && link.name.includes('Sportbook')
            ? 'pointer-events-none opacity-50 cursor-not-allowed '
            : '') +
          'btn group relative hover:bg-hoverIcon rounded-xl items-center min-h-12 flex justify-center ' +
          (isSidebar
            ? link.isActive
              ? 'bg-darkBlueBgLight'
              : 'bg-defaultIcon'
            : link.isActive
              ? 'bg-mainBgLight'
              : 'bg-smallContainerBgLight')
        "
        (click)="buttonClick(link.url)">
        <div class="min-w-[1.5rem] max-w-[1.5rem] max-h-8">
          <img [src]="link.svg" [class]="'filter-svg ' + (link.isActive ? 'filter-active' : '')" />
        </div>
        <div
          class="drawer hidden fixed md:group-hover:block text-mainText bg-tooltipLight rounded-lg px-3 py-2 top-[5rem] text-center z-40 text-xs font-medium">
          {{ t(link.name) }}
        </div>
      </button>
    </ng-container>
  </div>
</ng-container>
